<script>
import api from '@/api'
import { alertSuccess, alertError } from '@/helpers/swal'
import pagination from '@/components/pagination.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { convertDateFromGMTToLocal } from '@/helpers/date'

export default {
  props: {
    host: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loading: true,
      pagetitle: 'Pending Alerts',
      alerts: [],
      alertId: null,
      ackAlert: {
        ackBy: '',
        ackRemarks: '',
        ackTime: '',
        acknowledged: true,
        alertId: null,
        id: 0,
      },
      ackBtnDisabled: false,
      users: [],
      selectedUser: null,
      assignAlertId: null,
      assignedTo: null,
      totalItems: 0,
      totalPages: 1,
      currentPage: 0,
      perPage: 50,
      baseUrl: `${window.apiUrl}/alerts/pending`,
      remarks: '',
      assignedToMe: false,
      activeTab: 'pending',
      exportBtnDisabled: false,
      searchHost: '',
      components: [
        { name: 'Device', value: 'monitoring_alert' },
        { name: 'Memory', value: 'memory_alerts' },
        { name: 'Memory EZELINK', value: 'memory_alerts_collectd' },
        { name: 'Disk', value: 'disk_alerts' },
        { name: 'Disk EZELINK', value: 'disk_alerts_collectd' },
        { name: 'CPU', value: 'cpu_alerts' },
        { name: 'CPU EZELINK', value: 'cpu_alerts_collectd' },
        { name: 'Interface', value: 'interface_alerts'},
        { name: 'Web Service', value: 'web_service_alert'},
        { name: 'Database Service', value: 'database_service_alert'},
        { name: 'Monitoring Service', value: 'monitoring_service_alert'},
        { name: 'Cache Service', value: 'cache_service_alert'},
        { name: 'Zero User', value: 'zero_user_alert'},
        { name: 'License Utilization', value: 'license_utilization_alert' },
        { name: 'Sync Status', value: 'sync_status_alert' },
        { name: 'HA Status', value: 'ha_status_alert' },
      ],
      alertLevels: ['Critical', 'Warning'],
      categories: [],
      filters: {
        measurement: null,
        alertLevelCurrent: null,
        category: null,
      },
      sortBy: 'time',
      sortDir: 'desc',
      columns: [
        { name: 'time', label: 'Time', sortable: true },
        { name: 'measurement', label: 'Component', sortable: false },
        { name: 'agentHost', label: 'Device', sortable: true },
        { name: 'alertLevelCurrent', label: 'Level', sortable: false },
        { name: 'alertMessage', label: 'Message', sortable: false },
        { name: 'category', label: 'Category', sortable: false },
        { name: 'assignedTo', label: 'Assigned To', sortable: true },
      ],
      ackColumns: [
        { name: 'ackTime', label: 'Acknowledged At', sortable: true },
        { name: 'ackBy', label: 'Acknowledged By', sortable: true },
        { name: 'ackRemarks', label: 'Remarks', sortable: false },
      ],
    }
  },
  components: {
    pagination,
    vSelect,
  },
  async mounted() {
    await this.getCategories()
    // await this.getUsers()
    if (
        this.authUserHasPermission('ack_alerts_add') ||
        this.authUserHasPermission('alert_assign') ||
        this.authUserHasPermission('alert_unassign')
    ) {
        await this.getUsers(); // Calls the users endpoint only if permitted
    }

    this.filters = {
      measurement: this.measurement || null,
      alertLevelCurrent: this.alertLevelCurrent || null,
      category: this.category || null,
    }

    if (this.host) {
      this.searchHost = this.host
    }

    this.refreshInterval = setInterval(() => {
      this.applyFilters();
    }, 60000);
  },
  unmounted(){
    if(this.refreshInterval) {
        clearInterval(this.refreshInterval);
    }
  },
  watch: {
    filters: {
      handler() {
        this.applyFilters()
      },
      deep: true,
    },
  },
  methods: {
    convertDateFromGMTToLocal,
    async getCategories() {
      await api
        .get(`${window.apiUrl}/category/getCategories`)
        .then((response) => {
          this.categories = response.data || []
        })
        .finally(() => {
          this.loading = false
        })
    },

    async getAlerts() {
      this.loading = true
      let params = {
        page: this.currentPage,
        size: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir,
        measurement: this.filters.measurement,
        alertLevelCurrent: this.filters.alertLevelCurrent,
        category: this.filters.category,
      }
      if (this.assignedToMe) {
        params.assignedTo = this.authUser.username
      }
      if (this.searchHost) {
        params.agentHost = this.searchHost
      }
      await api
        .get(this.baseUrl, { params })
        .then((response) => {
          this.alerts = this.activeTab === 'pending' ? response.data?.alerts || [] : response.data?.ackAlerts || []
          this.totalItems = response.data.totalItems
          this.totalPages = response.data.totalPages
          this.currentPage = response.data.currentPage
        })
        .finally(() => {
          this.loading = false
        })
    },

    acknowledgeAlert() {
      this.ackBtnDisabled = true
      const url = `${window.apiUrl}/ack/alerts/${this.ackAlert.alertId}`
      const data = this.ackAlert

      api
        .post(url, data)
        .then(() => {
          alertSuccess('Alert acknowledged successfully')
          this.getAlerts()
        })
        .finally(() => {
          this.ackBtnDisabled = false
        })
    },

    unacknowledgeAlert(id) {
      api.post(`/ack/alerts/unacknowledge/${id}`).then(() => {
        alertSuccess('Alert unacknowledged successfully')
        this.getAlerts()
      })
    },

    async getUsers() {
      const params = {
        size: 100,
      }
      await api.get('/admin/accounts/list/basic', { params }).then((response) => {
        this.users = response.data?.users || []
        this.selectedUser = this.users.length ? this.users[0] : null
      })
    },

    assignAlert() {
      const params = new URLSearchParams({
        username: this.selectedUser.username,
      })
      api.post(`/alerts/assign/${this.assignAlertId}`, params).then(() => {
        alertSuccess('Alert assigned successfully')
        this.getAlerts()
      })
    },

    unassignAlert(id) {
      api.post(`/alerts/unassign/${id}`).then(() => {
        alertSuccess('Alert unassigned successfully')
        this.getAlerts()
      })
    },

    loadAssignAlertModalData(alert) {
      this.assignAlertId = alert.id
      this.assignedTo = alert.assignedTo
      this.selectedUser = this.assignedTo ? this.users.find((user) => user.username === this.assignedTo) : this.users[0]
    },

    toggleAssignedToMe() {
      this.assignedToMe = !this.assignedToMe
      this.getAlerts()
    },

    toggleTab(tab) {
      this.baseUrl = tab === 'pending' ? `${window.apiUrl}/alerts/pending` : `${window.apiUrl}/ack/alerts/list`
      this.activeTab = tab
      this.currentPage = 0
      this.sortBy = tab === 'pending' ? 'time' : 'ackTime'
      this.alertLevels = ['Critical', 'Warning']
      this.getAlerts()
    },

    applyFilters() {
      this.currentPage = 0
      this.getAlerts()
    },

    sortByColumn(column) {
      if (column.sortable) {
        this.sortBy = column.name
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
        this.currentPage = 0
        this.getAlerts()
      }
    },

    updatePage(newPage) {
      this.currentPage = newPage - 1
      this.getAlerts()
    },

    alertType(measurement) {
      let type = ''
      if (measurement === 'monitoring_alert') {
        type = 'Device'
      } else if (measurement === 'memory_alerts' || measurement === 'memory_alerts_collectd') {
        type = 'Memory'
      } else if (measurement === 'disk_alerts' || measurement === 'disk_alerts_collectd') {
        type = 'Disk'
      } else if (measurement === 'cpu_alerts' || measurement === 'cpu_alerts_collectd') {
        type = 'CPU'
      } else if (measurement === 'interface_alerts') {
        type = 'Interface'
      } else if (measurement === 'interface_error_alert') {
        type = 'Interface Error'
      } else if (measurement === 'zero_user_alert') {
        type = 'Zero User'
      } else if (measurement === 'web_service_alert') {
        type = 'Web Service'
      } else if (measurement === 'database_service_alert') {
        type = 'Database Service'
      } else if (measurement === 'monitoring_service_alert') {
        type = 'Monitoring Service'
      } else if (measurement === 'cache_service_alert') {
        type = 'Cache Service'
      } else if (measurement === 'license_utilization_alert') {
        type = 'License Utilization'
      } else if (measurement === 'sync_status_alert') {
        type = 'Sync Status'
      } else if (measurement === 'ha_status_alert') {
        type = 'HA Status'
      }
      return type
    },

    exportData() {
      if (!this.alerts.length) {
        alertError('There is no data to export')
        return
      }

      this.exportBtnDisabled = true
      const exportUrl = this.activeTab === 'pending' ? '/alerts/pending/export' : '/ack/alerts/export'
      api
        .get(exportUrl)
        .then((response) => {
          let csvString = response.data
          this.exportCSVStringToFile(this.activeTab === 'pending' ? 'Pending Alerts.csv' : 'Acknowledged Alerts.csv', csvString)
        })
        .finally(() => {
          this.exportBtnDisabled = false
        })
    },

    exportCSVStringToFile(filename, csvString) {
      const blob = new Blob(['\uFEFF' + csvString], { type: 'text/csv;charset=utf-8;' }) // Add BOM for Excel compatibility
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    showActionColumn() {
      return this.authUserHasPermission('ack_alerts_add') || this.authUserHasPermission('alert_assign') || this.authUserHasPermission('alert_unassign')
    },
  },
}
</script>

<template>
  <Teleport to="#elePageTitle">
    {{ pagetitle }}
  </Teleport>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row g-3 align-items-center">
            <div class="col-lg-7">
              <div class="row g-2">
                <div class="col-md-3">
                  <form @submit.prevent="applyFilters()">
                    <div class="input-group">
                      <input type="search" class="form-control" placeholder="Device" v-model="searchHost" />
                      <span class="input-group-text cursor-pointer" @click="applyFilters()">
                        <i class="bx bx-search"></i>
                      </span>
                    </div>
                  </form>
                </div>
                <div class="col-md-3">
                  <v-select id="component-input" v-model="filters.measurement" :options="components" label="name" placeholder="Component" :reduce="(component) => component.value">
                    <template #open-indicator="{ attributes, isOpen }">
                      <i class="font-size-22 fw-semibold bx" :class="isOpen ? 'bx-chevron-up' : 'bx-chevron-down'" v-bind="attributes"></i>
                    </template>
                  </v-select>
                </div>
                <div class="col-md-3">
                  <v-select id="level-input" v-model="filters.alertLevelCurrent" :options="alertLevels" placeholder="Level">
                    <template #open-indicator="{ attributes, isOpen }">
                      <i class="font-size-22 fw-semibold bx" :class="isOpen ? 'bx-chevron-up' : 'bx-chevron-down'" v-bind="attributes"></i>
                    </template>
                  </v-select>
                </div>
                <div class="col-md-3">
                  <v-select id="category-input" v-model="filters.category" :options="categories" label="categoryName" placeholder="Category" :reduce="(category) => category.categoryName">
                    <template #open-indicator="{ attributes, isOpen }">
                      <i class="font-size-22 fw-semibold bx" :class="isOpen ? 'bx-chevron-up' : 'bx-chevron-down'" v-bind="attributes"></i>
                    </template>
                  </v-select>
                </div>
              </div>
              <!-- <div class="input-group">
                <input type="search" class="form-control" placeholder="Search here" />
                <span class="input-group-text cursor-pointer">
                  <i class="bx bx-search"></i>
                </span>
              </div> -->
            </div>
            <div class="col-lg-5">
              <div class="d-flex justify-content-end align-items-center gap-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="assigned-to-me" @change="toggleAssignedToMe()" />
                  <label class="form-check-label" for="assigned-to-me">Assigned to me</label>
                </div>
                <ul class="nav nav-tabs nav-tabs-custom" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" data-bs-toggle="tab" href="#pending" role="tab" aria-selected="true" @click="toggleTab('pending')">
                      <span class="d-block d-sm-none">
                        <eva-icon class="icon nav-icon" name="alert-triangle-outline"></eva-icon>
                      </span>
                      <span class="d-none d-sm-block">Pending</span>
                    </a>
                  </li>
                  <li v-if="authUserHasPermission('ack_alerts_list')" class="nav-item">
                    <a class="nav-link" data-bs-toggle="tab" href="#acknowledged" role="tab" aria-selected="false" @click="toggleTab('acknowledged')">
                      <span class="d-block d-sm-none">
                        <eva-icon class="icon nav-icon" name="checkmark-circle-2-outline"></eva-icon>
                      </span>
                      <span class="d-none d-sm-block">Acknowledged</span>
                    </a>
                  </li>
                </ul>
                <button v-if="authUserHasPermission('pending_alerts_export')" class="btn btn-light d-flex align-items-center gap-1" @click="exportData()" :disabled="exportBtnDisabled">
                  <i v-if="exportBtnDisabled" class="bx bx-loader bx-spin"></i>
                  <i v-else class="bx bx-export"></i>
                  Export
                </button>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th v-for="(column, columnIndex) in columns" :key="columnIndex" @click="sortByColumn(column)" :class="column.sortable ? 'cursor-pointer' : ''">
                        <div class="d-flex align-itmes-center justify-content-between">
                          <span class="text-nowrap">{{ column.label }}</span>
                          <i v-if="sortBy === column.name" :class="'bx bx-sort-' + (sortDir === 'asc' ? 'up' : 'down') + ' font-size-20'"></i>
                          <i v-else-if="column.sortable" class="bx bx-sort font-size-20"></i>
                        </div>
                      </th>
                      <template v-if="activeTab === 'acknowledged'">
                        <th v-for="(ackColumn, ackColumnIndex) in ackColumns" :key="ackColumnIndex" @click="sortByColumn(ackColumn)" :class="ackColumn.sortable ? 'cursor-pointer' : ''">
                          <div class="d-flex align-itmes-center justify-content-between">
                            <span class="text-nowrap">{{ ackColumn.label }}</span>
                            <i v-if="sortBy === ackColumn.name" :class="'bx bx-sort-' + (sortDir === 'asc' ? 'up' : 'down') + ' font-size-20'"></i>
                            <i v-else-if="ackColumn.sortable" class="bx bx-sort font-size-20"></i>
                          </div>
                        </th>
                      </template>
                      <th v-if="(activeTab === 'pending' && showActionColumn()) || authUserHasPermission('ack_alerts_remove')">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr v-for="n in 5" :key="n">
                        <td v-for="m in activeTab === 'pending' ? (showActionColumn() ? 8 : 7) : authUserHasPermission('ack_alerts_remove') ? 11 : 10" :key="m" class="placeholder-glow">
                          <span class="placeholder col-12"></span>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="alerts.length">
                      <tr v-for="(alert, alertIndex) in alerts" :key="alertIndex">
                        <template v-if="activeTab === 'pending'">
                          <td>{{ convertDateFromGMTToLocal(alert.time) }}</td>
                          <td>{{ alertType(alert.measurement) }}</td>
                          <td class="text-uppercase">{{ alert.agentHost }}</td>
                          <td>
                            <span v-if="alert.alertLevelCurrent.toLowerCase() === 'critical'" class="badge badge-alert bg-danger text-uppercase">
                              <i class="mdi mdi-alert-rhombus"></i>
                              critical
                            </span>
                            <span v-else-if="alert.alertLevelCurrent.toLowerCase() === 'warning' || 
                                  alert.alertLevelCurrent.toLowerCase() === 'trouble'" 
                                  class="badge badge-alert bg-warning text-uppercase">
                              <i class="mdi mdi-alert-circle"></i>
                              warning
                            </span>
                          </td>
                          <td>{{ alert.alertMessage }}</td>
                          <td>{{ alert.category }}</td>
                          <td>
                            <span v-if="alert.assignedTo">{{ alert.assignedTo }}</span>
                            <span v-else>None</span>
                          </td>
                        </template>
                        <template v-else-if="activeTab === 'acknowledged'">
                          <td>{{ alert.alertDetails.time }}</td>
                          <td>{{ alertType(alert.alertDetails.measurement) }}</td>
                          <td>{{ alert.alertDetails.agentHost }}</td>
                          <td>
                            <span v-if="alert.alertDetails.alertLevelCurrent.toLowerCase() === 'critical'" class="badge badge-alert bg-danger text-uppercase">
                              <i class="mdi mdi-alert-rhombus"></i>
                              critical
                            </span>
                            <span
                              v-else-if="alert.alertDetails.alertLevelCurrent.toLowerCase() === 'warning' || alert.alertDetails.alertLevelCurrent.toLowerCase() === 'trouble'"
                              class="badge badge-alert bg-warning text-uppercase"
                            >
                              <i class="mdi mdi-alert-circle"></i>
                              warning
                            </span>
                          </td>
                          <td>{{ alert.alertDetails.alertMessage }}</td>
                          <td>{{ alert.alertDetails.category }}</td>
                          <td>
                            <span v-if="alert.alertDetails.assignedTo">{{ alert.alertDetails.assignedTo }}</span>
                            <span v-else>None</span>
                          </td>
                          <td>{{ alert.ackTime }}</td>
                          <td>{{ alert.ackBy }}</td>
                          <td>{{ alert.ackRemarks }}</td>
                        </template>
                        <td v-if="showActionColumn() || authUserHasPermission('ack_alerts_remove')">
                          <div class="d-flex gap-2">
                            <template v-if="activeTab === 'pending'">
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                data-bs-placement="top"
                                title="Acknowledge"
                                data-bs-toggle="modal"
                                data-bs-target="#acknowledgeAlertModal"
                                v-if="authUserHasPermission('ack_alerts_add') && (!alert.ackAlert || (alert.ackAlert && !alert.ackAlert.acknowledged))"
                                @click="ackAlert.alertId = alert.id"
                              >
                                <eva-icon name="checkmark" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                              </button>
                              <button
                                v-if="authUserHasPermission('alert_assign') && !alert.assignedTo"
                                type="button"
                                class="btn btn-secondary btn-sm"
                                data-bs-placement="top"
                                title="Assign to user"
                                data-bs-toggle="modal"
                                data-bs-target="#assignAlertModal"
                                @click="loadAssignAlertModalData(alert)"
                              >
                                <eva-icon name="person-add-outline" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                              </button>
                              <button v-else-if="authUserHasPermission('alert_unassign')" type="button" class="btn btn-danger btn-sm" title="Unassign" @click="unassignAlert(alert.id)">
                                <eva-icon name="person-remove-outline" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                              </button>
                            </template>
                            <template v-else-if="authUserHasPermission('ack_alerts_remove')">
                              <button type="button" class="btn btn-danger btn-sm" title="Unacknowledge" @click="unacknowledgeAlert(alert.alertId)">
                                <eva-icon name="close" data-eva-height="14" data-eva-width="14" class="fill-white align-text-top"></eva-icon>
                              </button>
                            </template>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td :colspan="activeTab === 'pending' ? 8 : 11" class="text-center">No alerts found</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- end row -->
        </div>
        <div v-if="!loading && alerts.length" class="card-footer">
          <pagination :baseUrl="baseUrl" :totalItems="totalItems" :perPage="perPage" :currentPage="currentPage + 1" @page-changed="updatePage" />
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="acknowledgeAlertModal" tabindex="-1" role="dialog" aria-labelledby="acknowledgeAlertModalLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header justify-content-center">
          <h5 class="modal-title" id="acknowledgeAlertModalLabel">Acknowledge Alert</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="acknowledgeAlert()">
            <div class="form-floating form-floating-custom mb-4">
              <textarea class="form-control" id="input-remarks" v-model="ackAlert.ackRemarks"></textarea>
              <label for="input-remarks">Remarks</label>
              <div class="form-floating-icon">
                <eva-icon name="message-circle-outline"></eva-icon>
              </div>
            </div>
            <div class="mb-3">
              <button class="btn btn-primary w-100 waves-effect waves-light" @click.prevent="acknowledgeAlert()" data-bs-dismiss="modal" :disabled="ackBtnDisabled">Acknowledge</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="assignAlertModal" tabindex="-1" role="dialog" aria-labelledby="assignAlertModalLabel">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header justify-content-center">
          <h5 class="modal-title" id="assignAlertModalLabel">Assign Alert To User</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="assignAlert()">
            <div class="form-floating form-floating-custom mb-4">
              <select class="form-select" id="select-user" v-model="selectedUser">
                <option v-for="(user, userIndex) in users" :key="userIndex" :value="user">{{ user.username }}</option>
              </select>
              <label for="select-user">Select user</label>
              <div class="form-floating-icon">
                <eva-icon name="person-outline"></eva-icon>
              </div>
            </div>
            <div class="mb-3">
              <button class="btn btn-primary w-100 waves-effect waves-light" @click.prevent="assignAlert()" data-bs-dismiss="modal" :disabled="ackBtnDisabled">Assign</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
